import { ActionContext, ActionTree, GetterTree } from 'vuex';
import { ShohiyouKoumoku } from '@/models/ShohiyouKoumoku';


export interface State {
  shohiyouKoumoku: ShohiyouKoumoku[];
}

// for initial data
const initialState: State = {
  shohiyouKoumoku: [],
};

// for stored data
const states: State = {
  ...initialState,
};

const actions: ActionTree<any, any> = {
  setShohiyouKoumoku({ commit }: ActionContext<State, string>, payload: ShohiyouKoumoku[]): void {
    commit('setShohiyouKoumoku', payload);
  },
  getShohiyouKoumoku({ commit }: ActionContext<State, any>): void {
    commit('getShohiyouKoumoku');
  },
  resetShohiyouKoumoku({ commit }: ActionContext<State, any>): void {
    commit('resetShohiyouKoumoku');
  },
};

const mutations = {
  setShohiyouKoumoku(state: State, payload: ShohiyouKoumoku[]) {
    state.shohiyouKoumoku = [...payload];
  },
  resetToken(state: State) {
    state.shohiyouKoumoku = initialState.shohiyouKoumoku;
  },
};

const getters: GetterTree<State, any> = {
  getShohiyouKoumoku(state): ShohiyouKoumoku[] {
    return state.shohiyouKoumoku;
  },
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: states,
  getters,
  actions,
  mutations,
};
